import { render, staticRenderFns } from "./Presumptive.vue?vue&type=template&id=039c7368&scoped=true"
import script from "./Presumptive.vue?vue&type=script&lang=js"
export * from "./Presumptive.vue?vue&type=script&lang=js"
import style0 from "./Presumptive.vue?vue&type=style&index=0&id=039c7368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039c7368",
  null
  
)

export default component.exports